import { isMarketEntity as s } from "./index.es281.js";
import "./index.es175.js";
import "./index.es176.js";
import { createFabricImageFromSvgString as n } from "./index.es454.js";
import { zipCodeSVG as a, addressSVG as c } from "./index.es455.js";
const g = (r) => {
  let t;
  return s({ entity_section: r }) ? t = a : t = c, t;
}, y = async ({
  categoryInfo: r,
  categorySvgUrl: t,
  entitySection: e
}) => {
  const i = r.sub_category, o = !t || i === "Address" || i === "District" ? g(e) : t;
  return await n(o);
};
export {
  y as createCategoryFabricObj
};
//# sourceMappingURL=index.es394.js.map
